<template>
  <div class="tutorial-progress">
    <!-- Progress Dots -->
    <div class="progress-dots">
      <button
        v-for="(_, index) in total"
        :key="index"
        class="progress-dot"
        :class="{ active: index === current, completed: index < current }"
        @click="$emit('dot-click', index)"
        :aria-label="`步驟 ${index + 1}`"
      />
    </div>

    <!-- Step Counter -->
    <div class="step-counter">
      {{ current + 1 }} / {{ total }}
    </div>

    <!-- Skip Button -->
    <button
      v-if="showSkip"
      class="skip-button"
      @click="$emit('skip')"
    >
      跳過教學
    </button>
  </div>
</template>

<script>
export default {
  name: 'TutorialProgress',

  props: {
    current: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    showSkip: {
      type: Boolean,
      default: true
    }
  },

  emits: ['skip', 'dot-click']
};
</script>

<style lang="scss" scoped>
.tutorial-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.progress-dots {
  display: flex;
  gap: 8px;
}

.progress-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background-color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  padding: 0;
  transition: all 0.3s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.6);
    transform: scale(1.2);
  }

  &.active {
    background-color: #ffffff;
    transform: scale(1.2);
  }

  &.completed {
    background-color: rgba(255, 255, 255, 0.8);
  }
}

.step-counter {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
}

.skip-button {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: rgba(255, 255, 255, 0.8);
  padding: 6px 16px;
  border-radius: 16px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.8);
    color: #ffffff;
  }
}
</style>
